<template>
  <div>
    <div class="text-end ma-6">
      <v-btn @click="dialog = !dialog" medium color="primary">
        <v-icon left>mdi-pencil</v-icon>
        Cập nhật
      </v-btn>
    </div>
    <v-card class="ma-6 pa-6" outlined>
      <div class="d-flex align-center">
        <div class="mr-2">Điểm lớp học:</div>
        <div class="font-weight-bold">
          {{ slot | _get('classNote.data.classMark', '') }}
        </div>
      </div>
      <div>
        <span>
          Nhận xét của giáo viên:
        </span>
        <span class="font-weight-bold">
          {{ slot | _get('classNote.data.classComment', '') }}
        </span>
      </div>
    </v-card>
    <ClassCommentUpdateDialog
      :state="dialog"
      :classComment="$_get(slot, 'classNote.data.classComment')"
      :classMark="$_get(slot, 'classNote.data.classMark')"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ClassCommentUpdateDialog from '@/modules/classNote/teacherSide/ClassCommentUpdateDialog.vue'
export default {
  data() {
    return {
      dialog: null
    }
  },
  components: {
    ClassCommentUpdateDialog
  },
  methods: {},
  computed: { ...mapState('ClassNoteDetail', ['slot']) }
}
</script>

<style></style>
